import { render, staticRenderFns } from "./drawerNoteComp.vue?vue&type=template&id=23328c97&scoped=true"
import script from "./drawerNoteComp.vue?vue&type=script&lang=js"
export * from "./drawerNoteComp.vue?vue&type=script&lang=js"
import style0 from "./drawerNoteComp.vue?vue&type=style&index=0&id=23328c97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23328c97",
  null
  
)

export default component.exports